import { render, staticRenderFns } from "./RegPrasymasRegistravimas.vue?vue&type=template&id=96a7c972&scoped=true&"
import script from "./RegPrasymasRegistravimas.vue?vue&type=script&lang=js&"
export * from "./RegPrasymasRegistravimas.vue?vue&type=script&lang=js&"
import style0 from "./RegPrasymasRegistravimas.vue?vue&type=style&index=0&id=96a7c972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a7c972",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VFooter,VRow,VSpacer})
